const makeCSV = nodes => {
  const header = `Title,Description,"Image Count","Attachment Count"\n`;
  const rows = nodes.reduce((output, node) => {
    const imageCount = node.images.filter(image => image !== null).length;
    const attachmentCount = node.attachments.length;
    const row = 
      `"${node.title}","${node.description || ''}",${imageCount},${attachmentCount}\n`;
    return output + row; 
  }, '');

  const csv = header + rows;
  return csv;
};

export default makeCSV;


// WEBPACK FOOTER //
// ./src/core/makeCSV.js